<template>
  <div>
    <a href="https://dornsife.usc.edu/bridge-institute/" target="_blank">
      <img v-if="displayMode === 'lightMode'" class="bridge" src="./img/Bridge.png" alt="USC Bridge Institute" title="USC Bridge Institute" />
      <img v-else class="bridge" src="./img/Bridge-darkMode.png" alt="USC Bridge Institute" title="USC Bridge Institute" />
    </a>
    <a href="https://www.frontiersin.org/journals/bioinformatics" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" id="frontiers" src="./img/frontiers.svg" alt="FBINF" title="Frontiers in Bioinformatics" />
      <img v-else id="frontiers" src="./img/frontiers-darkMode.svg" alt="FBINF" title="Frontiers in Bioinformatics" />
    </a>
  </div>
  <h4>Affiliations</h4>
  <div>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpeg" alt="ISCB" title="ISCB" />
    </a>
  </div>
  <h4>Media Partners</h4>
  <div>
    <a href="https://peerj.com/">
      <img src="./img/PeerJ.png" alt="PeerJ" title="PeerJ" />
    </a>
  </div>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.bridge {
  max-height: 40px;
  max-width: none;
}
img#frontiers {
  height: 2.3rem !important;
}
</style>
